import { FormTemplate } from '../types/formTypes';
import { BackendService } from './BackendService';

export default class FormTemplateService {
  static getAll(dealerId: string) {
    return BackendService.get<FormTemplate[]>('/formTemplates/all', {
      params: { dealerId },
    });
  }

  static create(body: Omit<FormTemplate, 'id'>) {
    return BackendService.post<FormTemplate>('/formTemplates', body);
  }

  static delete(id: string) {
    return BackendService.delete(`/formTemplates/${id}`);
  }
}
